export class ProcessResult {
  isSuccess: boolean;
  message: string;
}
